import React from 'react';
import {
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapper,
  Heading,
  Subtitle,
} from './InfoSection.elements';

const InfoSection = ({
  primary,
  lightBg,
  lightTopLine,
  lightText,
  lightTextDesc,
  headline,
  description,
  imgStart,
}) => {
  return (
    <InfoSec lightBg={lightBg}>
      <InfoRow imgStart={imgStart}>
        <InfoColumn>
          <TextWrapper>
            <Heading lightText={lightText}>{headline}</Heading>
            <Subtitle lightTextDesc={lightTextDesc}>{description}</Subtitle>
          </TextWrapper>
        </InfoColumn>
      </InfoRow>
    </InfoSec>
  );
};

export default InfoSection;
